function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.9775785,9 C13.7398043,11.638569 11.638569,13.7398043 9,13.9775785 L9,16 L8,16 L8,13.9775785 C5.36143101,13.7398043 3.2601957,11.638569 3.02242151,9 L1,9 L1,8 L3.02242151,8 C3.2601957,5.36143101 5.36143101,3.2601957 8,3.02242151 L8,1 L9,1 L9,3.02242151 C11.638569,3.2601957 13.7398043,5.36143101 13.9775785,8 L16,8 L16,9 L13.9775785,9 Z M8.5,12 C10.4329966,12 12,10.4329966 12,8.5 C12,6.56700338 10.4329966,5 8.5,5 C6.56700338,5 5,6.56700338 5,8.5 C5,10.4329966 6.56700338,12 8.5,12 Z M8.5,11 C7.11928813,11 6,9.88071187 6,8.5 C6,7.11928813 7.11928813,6 8.5,6 C9.88071187,6 11,7.11928813 11,8.5 C11,9.88071187 9.88071187,11 8.5,11 Z"
});
function SvgDiagramReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramReset);
export default __webpack_public_path__ + "static/media/diagram-reset.b49b69fd2255f63521ef0430337437d2.svg";
export { ForwardRef as ReactComponent };